var PaginationItemAriaLabelType;
(function (PaginationItemAriaLabelType) {
    PaginationItemAriaLabelType["PageNumber"] = "pageNumber";
    PaginationItemAriaLabelType["Previous"] = "previous";
    PaginationItemAriaLabelType["Next"] = "next";
})(PaginationItemAriaLabelType || (PaginationItemAriaLabelType = {}));
var PaginationItemType;
(function (PaginationItemType) {
    PaginationItemType["PageNumber"] = "pageNumber";
    PaginationItemType["Ellipsis"] = "ellipsis";
    PaginationItemType["Slash"] = "slash";
    PaginationItemType["Previous"] = "previous";
    PaginationItemType["Next"] = "next";
})(PaginationItemType || (PaginationItemType = {}));

export { PaginationItemType as P };
